/* eslint-disable no-undef */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import HttpClient from 'services/HttpClient';
import { getUserToken } from 'services/utils';
import { metrix } from 'services/metrixConfigure';
import { getBaseNewURL, getBaseURL } from 'services/getBaseURL';

const baseUrl = `${getBaseURL().base}`;
const newBaseURL = `${getBaseNewURL().base}`;

const http = new HttpClient();
const _metrix = metrix();
const initialState = {
	step: 1,
	statusStep: 1,
	message: '',
	token: 'null',
	isRegistered: null,
	profileState: {},
	isLoading: false,
	mobileState: null,
	path: null,
	otpError: false,
	status: null,
	sucsessRegistered: null,
	releseNoteState: {},
};

export const postMobileAuthentication = createAsyncThunk('/login/auth', async (params) => {
	const headers = {};
	const response = await http
		.post(`${baseUrl}/MobileAuthentication`, params, { headers: headers })
		.then((res) => {
			webengage?.track('Login Mobile Input', {
				'Mobile Number': String(params?.mobile?.replace('0', '+98')),
			});

			// bkrtk === Login Mobile Input
			_metrix.sendEvent('bkrtk', {
				'Mobile Number': String(params?.mobile?.replace('0', '+98')),
			});

			return res.data;
		});
	return response;
});

export const getReleseNote = createAsyncThunk('/', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http.post('/GetReleaseNote', params, extraConfig).then((res) => res.data);
	return response;
});

export const postMobileAuthorization = createAsyncThunk('/login/author', async (params) => {
	const headers = {};
	const response = await http
		.post(`${baseUrl}/MobileAuthorization`, params, { headers: headers })
		.then((res) => {
			const webEngageUID = res.data.Content?.WEUID;

			webengage.track('Login Mobile OTP Input', {
				'Mobile Number': String(params?.mobile?.replace('0', '+98')),
			});

			// hilnr === Login Mobile OTP Input
			_metrix.sendEvent('hilnr', {
				'Mobile Number': String(params?.mobile?.replace('0', '+98')),
			});

			webEngageUID && webengage.user.login(webEngageUID);

			// hilnr === User Login
			_metrix.sendEvent('adxwm');

			return res.data;
		});
	return response;
});

export const PostRegisteration = createAsyncThunk('/login/registeration', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const parameters = {
		'national_code': params.national_code,
	};
	const response = await http.post(`${newBaseURL}/Registration`, parameters, extraConfig).then((res) => {
		const webEngageUID = res.data.Content?.WEUID;
		webEngageUID &&
			webengage.track('Signup', {
				'Phone Number': String(thunkAPI.getState()?.login?.mobileState?.replace('0', '+98')),
				'Channel': 'Keepa-App',
			});

		_metrix.sendEvent('izaev', {
			'Phone Number': String(thunkAPI.getState()?.login?.mobileState?.replace('0', '+98')),
			'Channel': 'Keepa-App',
		});

		webEngageUID && webengage.user.login(webEngageUID);
		// hilnr === User Login
		_metrix.sendEvent('adxwm');

		return res.data;
	});
	return response;
});

export const PostPersonalInfo = createAsyncThunk('profile/personalinfo', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {};
	const response = await http.post(`${baseUrl}/GetInfo`, param, extraConfig).then((res) => {
		return res.data;
	});
	return response;
});

export const ProvinceAndCityList = createAsyncThunk('lists/provinceAndCity', async () => {
	const headers = {
		'Authorization': `Bearer 85370210-F4D9-46AB-88C2-83C4F3F43704`,
	};
	const param = {};
	const response = await http
		.post('/Get_ProvinceAndCityList', param, { headers: headers })
		.then((res) => res.data);
	return response;
});

const loginSlice = createSlice({
	name: 'login',
	initialState,
	reducers: {
		changedStep(state, action) {
			state.step = action.payload;
		},
		signOut() {
			localStorage.removeItem('persist:login');
			window.webengage.user.logout();

			return {
				...initialState,
				token: null,
			};
		},
		changeIsAuthenticated(state, action) {
			state.isAuthenticated = action.payload;
		},
		changedMessage(state, action) {
			state.message = action.payload;
		},
		setMobileActin(state, action) {
			state.mobileState = action.payload;
		},
		getReducerState(state) {
			return state;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(PostPersonalInfo.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(PostPersonalInfo.fulfilled, (state, action) => {
				state.isLoading = false;
				const { Success, Content, Message } = action.payload;
				if (Success) {
					state.profileState = Content;
				} else {
					state.errorMassege = Message;
				}
			})
			.addCase(PostPersonalInfo.rejected, (state) => {
				state.isLoading = false;
				state.error = 'خطا در بر قراری سرور';
			})
			.addCase(postMobileAuthentication.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(postMobileAuthentication.fulfilled, (state, action) => {
				const { Success } = action.payload;
				if (Success) {
					state.step = 2;
					//  toast.success("کد تأیید ارسال شد.")
				}
				state.isLoading = false;
			})
			.addCase(postMobileAuthentication.rejected, (state) => {
				state.isLoading = false;
				state.error = 'خطا در بر قراری سرور';
			})
			.addCase(postMobileAuthorization.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(postMobileAuthorization.fulfilled, (state, action) => {
				state.isLoading = false;
				const { Success, Message, Content } = action.payload;
				if (Success) {
					state.isRegistered = Content.isRegistered;
					state.token = Content.AccessToken;
					let isAndroid = JSON.parse(localStorage.getItem('isAndroid'));
					isAndroid && window.ANDROID.setToken(`${Content.AccessToken}`);
					localStorage.setItem('loginTimeStamp', '2');
					if (!Content.isRegistered) state.step = 3;
				} else {
					state.message = Message;
					state.otpError = true;
					navigator.vibrate(200);
				}
			})
			.addCase(postMobileAuthorization.rejected, (state) => {
				state.isLoading = false;
				state.error = 'خطا در بر قراری سرور';
			})
			.addCase(PostRegisteration.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(PostRegisteration.fulfilled, (state, action) => {
				state.isLoading = false;
				const { Success, Message, Content } = action.payload;
				if (Success) {
					state.message = '';
					state.token = Content.AccessToken;
					state.isRegistered = Content.isRegistered;
				} else {
					state.message = Message;
					state.sucsessRegistered = Success;
				}
			})
			.addCase(PostRegisteration.rejected, (state) => {
				state.isLoading = false;
				state.error = 'خطا در برقراری ارتباط با سرور';
			});
		builder
			.addCase(getReleseNote.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(getReleseNote.fulfilled, (state, action) => {
				state.isLoading = false;
				const { Content, Success, Message } = action.payload;
				if (Success) {
					state.releseNoteState = Content;
				} else {
					state.message = Message;
					state.error = 'خطا در برقراری ارتباط با سرور';
				}
			})
			.addCase(getReleseNote.rejected, (state) => {
				state.isLoading = false;
			});
	},
});
export const {
	changedStep,
	changedMessage,
	changeIsAuthenticated,
	setMobileActin,
	signOut,
	getReducerState,
} = loginSlice.actions;
export default loginSlice.reducer;
